import React, { useEffect, useMemo } from 'react';
import { PageBody } from '../../components/SiteWrapper';
import * as MinistryReportApi from '../../api/MinistryReportApi';
import DataTable from '../../components/DataTable';
import { useRowSpan } from '../../components/DataTable/useRowSpan';
import moment from 'moment';
import { OverlayTrigger, Popover } from 'react-bootstrap';

function FileUploadedStatus({ exam_id }) {
  const [data, setData] = React.useState([]);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [columns, setColumns] = React.useState([]);
  const fetchData = async () => {
    try {
      const response = await MinistryReportApi.getUploadedStatus({
        exam_id: exam_id?.value,
      });

      setData(response?.data?.data || []);
      setTotalRecords(response?.data?.totalRecords || 0);
      setColumns(generatePivotColumns(response?.data?.data || []));
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (exam_id) {
      fetchData();
    }
  }, [exam_id]);

  //   const columns = useMemo(
  //     () => [
  //       {
  //         Header: 'Exam Date',
  //         accessor: 'date',
  //         disableSortBy: true,
  //         enableRowSpan: true,
  //       },
  //       {
  //         Header: 'Shift',
  //         accessor: 'shift',
  //         enableRowSpan: true,
  //         disableSortBy: true,
  //       },
  //       {
  //         Header: 'Stages Of Exam',
  //         accessor: 'stage',
  //         enableRowSpan: true,
  //         disableSortBy: true,
  //       },
  //       { Header: 'No. of records', accessor: 'count', disableSortBy: true },
  //     ],
  //     []
  //   );

  return (
    <PageBody>
      <DataTable
        cardClass='shadow-none p-0 m-0'
        columns={columns}
        data={data}
        totalRecords={totalRecords}
        manual={true}
        tableHooks={(hooks) => {
          hooks.useInstance.push(useRowSpan);
        }}
        enableRowSpan
        hidePagination={true}
        hideSearch
        defaultPageLength={[100]}
        align='table-vcenter'
      />
    </PageBody>
  );
}

export default FileUploadedStatus;

const shiftColors = {
  shift1: 'rgb(203,235,174)',
  shift2: 'rgb(179,218,244)',
  shift3: 'rgb(255,224,143)',
};

const generatePivotColumns = (data) => {
  if (!data || data.length === 0) return [];

  const keys = Object.keys(data[0]);

  const stages = {
    'Drive Download': 'DD',
    'Allowed Candidates Login': 'ACL',
    'Exam Completion': 'EC',
    'Lock/Unlock Incidents': 'LUI',
    'Content Delivery': 'CD',
    'Content Process': 'CP',
    'Entry of Candidates': 'EOC',
    Registration: 'REG',
    'Aadhar Authentication': 'AA',
    'Exam Commencement': 'ECM',
    'Unique Candidates Detected with Lock / Unlock Incidents': 'UCDLUI',
  };

  return keys.map((key) => {
    if (key === 'date') {
      return {
        Header: 'Exam Date',
        accessor: 'date',
        disableSortBy: true,
        enableRowSpan: true,
        Cell: ({ value }) => moment(value).format('DD/MM/YYYY'),
      };
    } else if (key === 'shift') {
      return {
        Header: 'Shift',
        accessor: 'shift',
        disableSortBy: true,
        enableRowSpan: true,
        Cell: ({ value }) => (
          <div
            className='py-1 px-2 rounded'
            style={{ backgroundColor: shiftColors[value] }}
          >
            {value.slice(0, 1).toUpperCase() + value.slice(1)}
          </div>
        ),
      };
    } else {
      const overlayContent = (
        <Popover>
          <Popover.Body>{key}</Popover.Body>
        </Popover>
      );

      const categoryColors = {
        'Drive Download': 'rgb(254, 195, 190)',
        'Content Delivery': 'rgb(224,224,224)',
        'Content Process': 'rgb(255,224,143)',
        'Entry of Candidates': 'rgb(203,235,174)',
        Registration: 'rgb(179,218,244)',
        'Aadhar Authentication': 'rgb(187,211,218)',
        'Exam Commencement': 'rgb(223,194,238)',
        'Allowed Candidates Login': 'rgb(121,159,229)',
        'Exam Completion': 'rgb(144,132,219)',
        'Lock/Unlock Incidents': 'rgb(122,234,203)',
        'Unique Candidates Detected with Lock / Unlock Incidents':
          'rgb(122,234,203)',
      };

      return {
        Header: (
          //   <div className='scrolling-text-wrapper'>
          //     <div className='scrolling-text'>{key}</div>
          //   </div>
          <div className='d-flex align-items-center gap-1'>
            <div className='d-flex align-items-center gap-3'>
              <OverlayTrigger
                rootClose
                placement='top'
                overlay={overlayContent}
              >
                <div
                  className='rounded-circle cursor-pointer'
                  style={{
                    height: '10px',
                    width: '10px',
                    backgroundColor: categoryColors[key]
                      ? categoryColors[key]
                      : 'transparent',
                  }}
                ></div>
              </OverlayTrigger>
            </div>
            <div className='text-center'>{stages[key] ? stages[key] : key}</div>
          </div>
        ),
        accessor: key,
        disableSortBy: true,
        Cell: ({ value }) => (value && value === 0 ? '' : value ? value : ''),
      };
    }
  });
};
